var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'app-about-route': _vm.isAboutRoute, 'app-roboto-route': !_vm.isAboutRoute },attrs:{"id":"app"}},[_c('StoreHeader'),_c('Alert'),_c('router-view',{staticClass:"app-route-view"}),_c('TimedLeadPopups'),_c('SupportChatWidget')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }